// extracted by mini-css-extract-plugin
module.exports = {"mobile":"PhoneNumber_mobile__2s0Wr","desktop":"PhoneNumber_desktop__2kwuO","phoneIcon":"PhoneNumber_phoneIcon__17NpW"};